import MDXScopedRuntime from './components/MDXScopedRuntime';

export default MDXScopedRuntime;
